import React, { useEffect, useState } from "react";
import { HTTPURL } from "../../../constants/Matcher";
import { grade_all } from "../../../apis/Grade";
import { subject_all } from "../../../apis/ClassManagement/Subjects";
import {
  answer_booklets,
  answer_booklet_save,
  answer_booklet_delete,
} from "../../../apis/AnswerBooklet";

const TERMS = [1, 2, 3, 4];
const ALL_SUBJECTS = { id: 0, label: "All subjects" };

const gradeLabel = (name) => {
  const n = Number(name);
  if (isNaN(n)) return name || "—";
  return n === 0 ? "Kindy" : `Year ${n}`;
};

const fmtWhen = (s) => {
  if (!s) return "";
  const d = new Date(s);
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
};

const fileHref = (url) => (url?.startsWith("http") ? url : `${HTTPURL}${url?.replace(/^\//, "")}`);

const AnswerBooklets = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [grades, setGrades] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [filter, setFilter] = useState({ year: "", grade_id: "", term: "", subject_id: "" });
  const [modal, setModal] = useState(null); // {edit?: row}

  const userId = (() => {
    try { return JSON.parse(localStorage.getItem("userData"))?.data?.id; } catch { return null; }
  })();

  const load = async () => {
    setLoading(true);
    const res = await answer_booklets(filter);
    setRows(res?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    grade_all().then((r) => setGrades(r?.data || []));
    subject_all().then((r) => setSubjects(r?.data || []));
  }, []);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const remove = async (row) => {
    if (!window.confirm(`Delete the answer booklet for ${gradeLabel(row.grade_name)} · Term ${row.term} · ${row.subject_id === 0 ? "All subjects" : row.subject_name}?`)) return;
    const res = await answer_booklet_delete(row.id);
    if (res?.status) load();
  };

  const subjectLabel = (row) =>
    row.subject_id === 0 ? "All subjects" : (row.subject_name || `#${row.subject_id}`);

  return (
    <div className="right-nav" id="dash-event" style={{ padding: "20px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        <div>
          <h4 style={{ fontSize: 18, fontWeight: 600, margin: 0, color: "#1a1a2e" }}>Answer Booklets</h4>
          <p style={{ fontSize: 12, color: "#64748b", margin: "4px 0 0" }}>
            PDF answer keys by year, grade, term and subject. Students see their grade's current-term booklets.
          </p>
        </div>
        <button className="ui button" style={{ fontSize: 13 }} onClick={() => setModal({})}>
          <i className="fa fa-upload" style={{ marginRight: 6 }} /> Upload Booklet
        </button>
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <input type="number" placeholder="Year" value={filter.year}
          onChange={(e) => setFilter((f) => ({ ...f, year: e.target.value }))}
          style={inp(90)} />
        <select value={filter.grade_id} onChange={(e) => setFilter((f) => ({ ...f, grade_id: e.target.value }))} style={inp(130)}>
          <option value="">All grades</option>
          {grades.map((g) => <option key={g.id} value={g.id}>{gradeLabel(g.name)}</option>)}
        </select>
        <select value={filter.term} onChange={(e) => setFilter((f) => ({ ...f, term: e.target.value }))} style={inp(110)}>
          <option value="">All terms</option>
          {TERMS.map((t) => <option key={t} value={t}>Term {t}</option>)}
        </select>
        <select value={filter.subject_id} onChange={(e) => setFilter((f) => ({ ...f, subject_id: e.target.value }))} style={inp(150)}>
          <option value="">All subjects (filter)</option>
          <option value="0">— All subjects doc —</option>
          {subjects.map((s) => <option key={s.id} value={s.id}>{s.subject}</option>)}
        </select>
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
        <div style={hdr}>
          <span>Year</span><span>Grade</span><span>Term</span><span>Subject</span>
          <span>File</span><span>Updated</span><span style={{ textAlign: "right" }}>Actions</span>
        </div>
        {loading ? (
          <div style={{ padding: 20, color: "#94a3b8", fontSize: 13 }}>Loading…</div>
        ) : rows.length === 0 ? (
          <div style={{ padding: 24, color: "#94a3b8", fontSize: 13 }}>No answer booklets yet.</div>
        ) : rows.map((row) => (
          <div key={row.id} style={rowStyle}>
            <span>{row.year}</span>
            <span>{gradeLabel(row.grade_name)}</span>
            <span>Term {row.term}</span>
            <span style={{ fontWeight: row.subject_id === 0 ? 600 : 400, color: row.subject_id === 0 ? "#7c3aed" : "#334155" }}>
              {subjectLabel(row)}
            </span>
            <span>
              <a href={fileHref(row.file_url)} target="_blank" rel="noopener noreferrer"
                 style={{ fontSize: 12, color: "#2563eb" }}>
                <i className="fa fa-file-pdf" style={{ marginRight: 4 }} />
                {row.original_filename || "PDF"}
              </a>
            </span>
            <span style={{ fontSize: 12, color: "#64748b" }}>{fmtWhen(row.updated_at)}</span>
            <span style={{ textAlign: "right", whiteSpace: "nowrap" }}>
              <button className="edit-btn" title="Replace file" onClick={() => setModal({ edit: row })}>
                <i className="fa fa-pencil" />
              </button>
              <button className="dlt-btn" title="Delete" onClick={() => remove(row)}>
                <i className="fa fa-trash" />
              </button>
            </span>
          </div>
        ))}
      </div>

      {modal && (
        <UploadModal
          grades={grades} subjects={subjects} userId={userId}
          edit={modal.edit}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </div>
  );
};

const UploadModal = ({ grades, subjects, userId, edit, onClose, onSaved }) => {
  const [year, setYear] = useState(edit?.year || new Date().getFullYear());
  const [gradeId, setGradeId] = useState(edit?.grade_id || "");
  const [term, setTerm] = useState(edit?.term || "");
  const [subjectId, setSubjectId] = useState(edit ? String(edit.subject_id) : "0");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!year || !gradeId || !term || !file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("year", year);
    fd.append("grade_id", gradeId);
    fd.append("term", term);
    fd.append("subject_id", subjectId);
    if (userId) fd.append("user_id", userId);
    const res = await answer_booklet_save(fd);
    setBusy(false);
    if (res?.status) onSaved();
  };

  return (
    <div onClick={onClose} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <h5 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#1f2937" }}>
            {edit ? "Replace answer booklet" : "Upload answer booklet"}
          </h5>
          <button onClick={onClose} type="button" style={xBtn}>×</button>
        </div>
        <form onSubmit={submit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Year *">
              <input type="number" className="form-control" style={{ fontSize: 13 }}
                value={year} onChange={(e) => setYear(e.target.value)} disabled={busy || !!edit} required />
            </Field>
            <Field label="Grade *">
              <select className="form-control" style={{ fontSize: 13 }} value={gradeId}
                onChange={(e) => setGradeId(e.target.value)} disabled={busy || !!edit} required>
                <option value="">Select grade</option>
                {grades.map((g) => <option key={g.id} value={g.id}>{gradeLabel(g.name)}</option>)}
              </select>
            </Field>
            <Field label="Term *">
              <select className="form-control" style={{ fontSize: 13 }} value={term}
                onChange={(e) => setTerm(e.target.value)} disabled={busy || !!edit} required>
                <option value="">Select term</option>
                {TERMS.map((t) => <option key={t} value={t}>Term {t}</option>)}
              </select>
            </Field>
            <Field label="Subject *">
              <select className="form-control" style={{ fontSize: 13 }} value={subjectId}
                onChange={(e) => setSubjectId(e.target.value)} disabled={busy || !!edit} required>
                <option value="0">{ALL_SUBJECTS.label}</option>
                {subjects.map((s) => <option key={s.id} value={s.id}>{s.subject}</option>)}
              </select>
            </Field>
          </div>
          {edit && (
            <p style={{ fontSize: 11, color: "#94a3b8", margin: "4px 0 0" }}>
              Grade / term / subject are fixed when replacing — just pick the new PDF to overwrite.
            </p>
          )}
          <Field label="PDF file *" hint="PDF only, up to 50 MB. Uploading overwrites any existing booklet for this combination.">
            <input type="file" accept="application/pdf" style={{ fontSize: 13 }}
              onChange={(e) => setFile(e.target.files?.[0] || null)} disabled={busy} required />
          </Field>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
            <button type="button" className="btn btn-secondary" style={{ fontSize: 13 }} onClick={onClose} disabled={busy}>Cancel</button>
            <button type="submit" className="btn btn-primary" style={{ fontSize: 13 }}
              disabled={busy || !year || !gradeId || !term || !file}>
              {busy ? "Uploading…" : (edit ? "Replace" : "Upload")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const Field = ({ label, hint, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, display: "block" }}>{label}</label>
    {children}
    {hint && <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>{hint}</div>}
  </div>
);

const COLS = "70px 110px 90px 1.2fr 1.6fr 110px 90px";
const hdr = {
  display: "grid", gridTemplateColumns: COLS, gap: 8,
  padding: "10px 14px", background: "#f9fafb",
  fontSize: 11, color: "#6b7280", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5,
};
const rowStyle = {
  display: "grid", gridTemplateColumns: COLS, gap: 8, alignItems: "center",
  padding: "12px 14px", borderTop: "1px solid #f1f5f9", fontSize: 13, color: "#334155",
};
const inp = (w) => ({ fontSize: 12, padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", background: "#fff", minWidth: w });
const overlay = {
  position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1050, padding: 24, overflowY: "auto",
};
const card = {
  background: "#fff", borderRadius: 10, maxWidth: 560, width: "100%",
  padding: "20px 24px", boxShadow: "0 20px 50px rgba(15,23,42,0.25)", maxHeight: "calc(100vh - 48px)", overflowY: "auto",
};
const xBtn = { background: "transparent", border: "none", fontSize: 22, color: "#94a3b8", cursor: "pointer", padding: 0 };

export default AnswerBooklets;
